





import {Component, Prop, Vue} from 'vue-property-decorator';
import MenuItem from '@/models/MenuItem';

@Component
export default class MenuComponent extends Vue {
  @Prop() private menuItem!: MenuItem;

  get isSelect(): boolean {

    return this.menuItem.activeRoutes.includes(this.$route.name as string) || this.isChildSelected
  }

  get isChildSelected(): boolean {
    let isChildSelected = false;

    this.menuItem.children.forEach(
      menuItemChild => {
        if(menuItemChild.activeRoutes.includes(this.$route.name as string)){
          isChildSelected = true
        }
      }
    );

    return isChildSelected;
  }
}
